export var stylizationWrapper: React.CSSProperties = {
    width:'100%', 
    textAlign: 'left'
}

export var stylizationWrapperRight: React.CSSProperties = {
    width:'100%', 
    textAlign: 'right'
}

export var stylizationWrapperCenter: React.CSSProperties = {
    width:'100%', 
    textAlign: 'center'
}

export var stylizationVerticalAlign: React.CSSProperties = {
    verticalAlign: 'middle',
}

export var stylizationVerticalAlignMargin: React.CSSProperties = {
    verticalAlign: 'middle',
    marginRight: '15px'
}

export var stylizationSmallAdditionalIcon: React.CSSProperties = {
    width: '16px',
    height: '16px',
    verticalAlign: 'middle'
}

export var iconStyle: React.CSSProperties = {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingRight: '5px',
    paddingLeft: '5px',
    cursor: 'pointer' 
}

export var iconStyleWithoutPointer: React.CSSProperties = {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingRight: '5px',
    paddingLeft: '5px'
}

export var iconStyleDisabled: React.CSSProperties = {
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingRight: '5px',
    paddingLeft: '5px',
    cursor: 'not-allowed', 
    opacity: '50%'
}

export var iconStyleInline: React.CSSProperties = {
    display: 'inline',
    verticalAlign: 'middle',
    paddingRight: '5px',
    paddingLeft: '5px',
    cursor: 'pointer' 
}

export var styleRightFlex: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    paddingRight: '15px'
}

export var styleFormField: React.CSSProperties = {
    width: '100%',
    paddingBottom: '5px',
    textAlign: 'left',
    whiteSpace: 'pre-line'
}

export var styleFormFieldHalf: React.CSSProperties = {
    width: '49%',
    paddingBottom: '5px',
    textAlign: 'left'
}

export var styleFormFieldOnThree: React.CSSProperties = {
    width: '32%',
    paddingBottom: '5px',
    textAlign: 'left'
}

export var styleFormFieldOnFour: React.CSSProperties = {
    width: '23.5%',
    paddingBottom: '5px',
    textAlign: 'left'
}

export var styleFormFieldOnSix: React.CSSProperties = {
    width: '15%',
    paddingBottom: '5px',
    textAlign: 'left'
}

export var styleFormFieldSeventyFive: React.CSSProperties = {
    width: '70%',
    paddingBottom: '5px',
    textAlign: 'left'
}

export var stylizationAlignRight: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end'
}